import {title} from "assets/jss/material-kit-react.jsx";
import imagesStyle from "assets/jss/material-kit-react/imagesStyles.jsx";
import tooltipsStyle from "assets/jss/material-kit-react/tooltipsStyle.jsx";


import metaBG from "assets/img/bubbles.png";

const metaPollStyle = theme => ({
  ...imagesStyle,
  ...tooltipsStyle,
  section: {
    paddingTop: 150,
    paddingBottom: 50,
    backgroundImage: `url(${metaBG})`,
    height: 550,
    [theme.breakpoints.down('xs')]: {
      height: 625,
    },
    [theme.breakpoints.down('sm')]: {
      backgroundSize: "150% auto",
    },
    backgroundPosition: "50% 100%",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  title: {
    ...title,
    marginTop: 30,
    marginBottom: 10,
    letterSpacing: 1,
    paddingLeft: 7,
    fontSize: 45,
    // lineHeight: 50,
    fontWeight: 400,
    textTransform: "none",
    textAlign: "left",
    color: "#707070",
  },
  bioDiv: {
    position: "relative",
    display: "block",
    maxWidth: 350,
    height: 350,
    [theme.breakpoints.down('xs')]: {
      height: 425,
    },
    marginRight: "auto",
    marginLeft: "auto",
    padding: "20px 30px 30px",
    // backgroundColor: "#fff",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    boxShadow: "1px 1px 19px 0 rgba(0, 0, 0, .16)",
  },
  profImgStyle: {
    position: "absolute",
    top: -45,
    right: -45,
    border: "5px solid #ff3e4b",
    borderRadius: 500,
  },
  linkUserPageBtn: {
    marginHorizontal: 0,
    padding: 0,
  },
  linkDescrEditBtn: {
    textTransform: 'none',
    padding: 0,
    textAlign: 'left',
    marginHorizontal: 0,
  },
  name: {
    fontSize: 18,
    margin: 3,
    padding: 0,
    // marginTop: 10,
    // marginBottom: 5,
    // marginRight: 5,
    textAlign: 'left',
    fontFamily: "Montserrat, sans-serif",
    fontWeight: "500",
    textTransform: "none",
    color: "#333",
  },
  disableLink: {
    pointerEvents: 'none',
  },
  divider: {
    [theme.breakpoints.down('xs')]: {
      maxWidth: "100%",
    },
    maxWidth: 200,
    height: 1,
    marginTop: 15,
    marginBottom: 15,
    backgroundColor: "#d7d7d7",
  },
  heading: {
    margin: 3,
    marginTop: 20,
    marginBottom: 10,
    fontSize: 24,
    fontFamily: "Montserrat, sans-serif",
    fontWeight: "500",
    textTransform: "none",
    color: "#333",
  },
  descrip: {
    margin: 3,
    marginBottom: 10,
    fontFamily: "Montserrat, sans-serif",
    fontSize: 12,
    fontWeight: 400,
  },
});

export default metaPollStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/pollTemplateSections/metaPollStyle.jsx